/* VetPro slide-cart drawer. Markup + data attributes live in
   snippets/cart-drawer.liquid; this file holds the behaviour.

   Extracted from an inline <script> so it is cached once instead of re-parsed on
   every page load — it renders on every page of the site. It no longer needs any
   Liquid: currency symbol and free-shipping threshold arrive as data attributes,
   and selling plans are fetched from /products/{handle}.js on open. */
(function () {
  'use strict';
  var root = document.getElementById('vp-cart');
  var SYM = (root && root.dataset.sym) || '$';
  var THRESHOLD = parseInt((root && root.dataset.threshold) || '5000', 10);
  // variantId -> { plan, price, regular }. Filled lazily from /products/{handle}.js.
  var PLANS = {};
  /* variantId -> the selling plan the line was last subscribed on. Switching to one-time and
     back used to land on PLANS[vid].plan, which is allocation [0] — the 1-Month plan on every
     product. A customer who chose "Every 2 months" in the buy box, flipped to one-time here to
     compare, and flipped back was quietly moved to monthly. Page-scoped: after a reload we
     fall back to the default, which is the best we can know. */
  var LAST_PLAN = {};
  var planHandles = {};   // handle -> true once requested (success or failure — never retried in a loop)

  // Look up selling plans for any product in the cart we haven't seen yet.
  // Resolves true when something new landed, so the caller knows to repaint.
  function ensurePlans(cart) {
    var wanted = [];
    (cart.items || []).forEach(function (i) {
      if (i.handle && !planHandles[i.handle]) { planHandles[i.handle] = true; wanted.push(i.handle); }
    });
    if (!wanted.length) return Promise.resolve(false);
    return Promise.all(wanted.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          p.variants.forEach(function (v) {
            var a = v.selling_plan_allocations && v.selling_plan_allocations[0];
            if (!a) return;
            PLANS[v.id] = {
              plan: a.selling_plan_id,
              price: (a.per_delivery_price != null ? a.per_delivery_price : a.price),
              regular: v.price
            };
          });
        })
        .catch(function () {});   // no plans for this product = no Subscribe toggle; not fatal
    })).then(function () { return true; });
  }

  var overlay = document.getElementById('vp-cart-overlay');
  var drawer = document.getElementById('vp-cart');
  var linesEl = document.getElementById('vp-cart-lines');
  var emptyEl = document.getElementById('vp-cart-empty');
  var footEl = document.getElementById('vp-cart-foot');
  var subtotalEl = document.getElementById('vp-cart-subtotal');
  var savingsEl = document.getElementById('vp-cart-savings');
  var shipEl = document.getElementById('vp-cart-ship');
  var shipMsg = document.getElementById('vp-cart-ship-msg');
  var shipFill = document.getElementById('vp-cart-ship-fill');
  var xsellEl = document.getElementById('vp-cart-xsell');
  var xsellList = document.getElementById('vp-cart-xsell-list');
  var refBanner = document.getElementById('vp-cart-refbanner');
  if (!drawer || !overlay) return;

  function hasReferral() { return /(?:^|;\s*)vp_ref_active=1(?:;|$)/.test(document.cookie); }

  /* Selling plan names are merchant-written in Recurpay and read badly on their own — a line
     saying "Subscription · 1 Month" doesn't echo the "Every month" the customer just chose in
     the buy box. Turn the common "<n> <unit>" shape into the same words; anything that doesn't
     fit that shape passes through untouched rather than mangled. The buy box does the same
     thing in Liquid — there's no module shared between an inline snippet script and an asset. */
  function cadenceLabel(name) {
    var m = /^\s*(\d+)\s+([a-z]+?)s?\s*$/i.exec(name || '');
    if (!m) return name;
    var n = parseInt(m[1], 10), unit = m[2].toLowerCase();
    return n === 1 ? 'Every ' + unit : 'Every ' + n + ' ' + unit + 's';
  }

  var busy = false;
  var xsellFor = null; // product id we last fetched recommendations for

  function money(cents) { return SYM + (Math.round(cents) / 100).toFixed(2); }
  // The pre-discount unit price to strike through: subscription lines compare to the one-time
  // regular price; otherwise fall back to any line-level (compare-at) discount. 0 = no strike.
  function unitWas(item) {
    if (item.selling_plan_allocation && PLANS[item.id] && PLANS[item.id].regular > item.final_price) return PLANS[item.id].regular;
    if (item.original_price > item.final_price) return item.original_price;
    return 0;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // Focus stays inside the drawer while it's open, and returns to whatever opened it on
  // close — otherwise Tab walks into the page behind and the customer is operating
  // controls they can't see.
  var releaseTrap = null;
  function setOpen(open) {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    overlay.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      var c = drawer.querySelector('[data-vp-cart-close]');
      if (c) c.focus();
      if (window.VPFocusTrap && !releaseTrap) releaseTrap = window.VPFocusTrap.trap(drawer);
    } else if (releaseTrap) {
      releaseTrap();
      releaseTrap = null;
    }
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-vp-cart-open]').forEach(function (link) {
      var badge = link.querySelector('.vp-header__cart-count');
      if (count > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'vp-header__cart-count'; link.appendChild(badge); }
        badge.textContent = count;
      } else if (badge) { badge.remove(); }
      link.setAttribute('aria-label', 'Cart, ' + count + ' items');
    });
  }

  function renderShip(subtotal, hasSub) {
    if (hasSub || subtotal >= THRESHOLD) {
      shipEl.hidden = false;
      shipMsg.innerHTML = '<strong>You’ve unlocked free shipping.</strong>';
      shipFill.style.width = '100%';
    } else if (subtotal > 0) {
      shipEl.hidden = false;
      shipMsg.innerHTML = 'You’re <strong>' + money(THRESHOLD - subtotal) + '</strong> away from free shipping.';
      shipFill.style.width = Math.min(100, (subtotal / THRESHOLD) * 100) + '%';
    } else {
      shipEl.hidden = true;
    }
  }

  function lineHTML(item) {
    var isSub = !!item.selling_plan_allocation;
    var canSub = !isSub && PLANS[item.id];
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
    var meta = [];
    if (item.variant_title && item.variant_title !== 'Default Title') meta.push(esc(item.variant_title));
    if (isSub) meta.push('Subscription · ' + esc(cadenceLabel(item.selling_plan_allocation.selling_plan.name)));

    var subRow = '';
    if (isSub) {
      /* The subscribed state is a STATUS with an action inside it, not one big button. It used
         to be a single <button> reading "Subscribed & saving | One-time instead", so clicking
         the words that said the line was subscribed silently cancelled the subscription — the
         label was wired to the thing that destroys it. Only "Switch to one-time" is clickable
         now, and it names what it does instead of leaving "instead of what?" to the reader. */
      subRow = '<span class="vp-cart__subtoggle is-on">' +
        '<span class="dot"></span>Subscribed &amp; saving' +
        '<button type="button" class="switch" data-plan-off="' + item.key + '" data-vid="' + item.id + '" data-qty="' + item.quantity + '"' +
        ' data-cur-plan="' + item.selling_plan_allocation.selling_plan.id + '">Switch to one-time</button>' +
        '</span>';
    } else if (canSub) {
      var save = (item.final_price - PLANS[item.id].price) * item.quantity;
      subRow = '<button type="button" class="vp-cart__subtoggle" data-plan-on="' + item.key + '" data-vid="' + item.id + '" data-qty="' + item.quantity + '">' +
        '<span class="dot"></span>Subscribe &amp; save' + (save > 0 ? ' <em>' + money(save) + '/order</em>' : '') + '</button>';
    }

    var wasUnit = unitWas(item);
    var wasLine = wasUnit ? wasUnit * item.quantity : 0;
    var priceHTML = (wasLine > item.final_line_price)
      ? '<span class="vp-cart__line-price"><span class="was">' + money(wasLine) + '</span><span class="now">' + money(item.final_line_price) + '</span></span>'
      : '<span class="vp-cart__line-price">' + money(item.final_line_price) + '</span>';

    return '<li class="vp-cart__line" data-key="' + item.key + '">' +
      '<a href="' + esc(item.url) + '" class="vp-cart__line-img">' + (img ? '<img src="' + esc(img) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
      '<div class="vp-cart__line-main">' +
        '<div class="vp-cart__line-top">' +
          '<a href="' + esc(item.url) + '" class="vp-cart__line-title">' + esc(item.product_title) + '</a>' +
          '<button type="button" class="vp-cart__line-remove" data-remove="' + item.key + '" aria-label="Remove">' +
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '</div>' +
        (meta.length ? '<p class="vp-cart__line-meta">' + meta.join(' · ') + '</p>' : '') +
        subRow +
        '<div class="vp-cart__line-bottom">' +
          '<div class="vp-cart__qty">' +
            '<button type="button" class="vp-cart__qty-btn" data-qty-minus="' + item.key + '" aria-label="Decrease quantity">−</button>' +
            '<span class="vp-cart__qty-n">' + item.quantity + '</span>' +
            '<button type="button" class="vp-cart__qty-btn" data-qty-plus="' + item.key + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          priceHTML +
        '</div>' +
      '</div>' +
    '</li>';
  }

  // render() = fetch any missing selling-plan data, then paint. Paints immediately too, so
  // the drawer never waits on the network to show its contents — the Subscribe & Save row
  // fills in a moment later on the first cart that contains a new product.
  function render(cart) {
    paint(cart);
    return ensurePlans(cart).then(function (gotNew) { if (gotNew) paint(cart); return cart; });
  }

  function paint(cart) {
    var count = cart.item_count || 0;
    updateHeaderCount(count);
    if (refBanner) refBanner.hidden = !(count > 0 && hasReferral());
    if (count === 0) {
      linesEl.innerHTML = '';
      emptyEl.hidden = false;
      footEl.hidden = true;
      xsellEl.hidden = true;
      shipEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footEl.hidden = false;
    var hasSub = cart.items.some(function (i) { return !!i.selling_plan_allocation; });
    linesEl.innerHTML = cart.items.map(lineHTML).join('');
    subtotalEl.textContent = money(cart.items_subtotal_price);
    var saved = 0;
    cart.items.forEach(function (i) { var w = unitWas(i); if (w) saved += (w * i.quantity) - i.final_line_price; });
    if (saved > 0) { savingsEl.hidden = false; savingsEl.textContent = 'You’re saving ' + money(saved) + '.'; }
    else savingsEl.hidden = true;
    renderShip(cart.items_subtotal_price, hasSub);
    loadXsell(cart.items[0]);
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function loadXsell(firstItem) {
    if (!firstItem) { xsellEl.hidden = true; return; }
    var pid = firstItem.product_id;
    if (pid === xsellFor && xsellList.children.length) { xsellEl.hidden = false; return; }
    xsellFor = pid;
    var recUrl = function (intent) { return '/recommendations/products.json?product_id=' + pid + '&limit=6&intent=' + intent; };
    // Complementary (curated in Search & Discovery) first; fall back to related if none are configured.
    fetch(recUrl('complementary'))
      .then(function (r) { return r.json(); })
      .then(function (data) { return (data.products && data.products.length) ? data : fetch(recUrl('related')).then(function (r) { return r.json(); }); })
      .then(function (data) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var inCart = {};
          cart.items.forEach(function (i) { inCart[i.product_id] = true; });
          var recs = (data.products || []).filter(function (p) { return !inCart[p.id] && p.available; }).slice(0, 3);
          if (!recs.length) { xsellEl.hidden = true; return; }
          xsellList.innerHTML = recs.map(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
            var img = (p.featured_image || (p.images && p.images[0]) || '');
            if (img && img.indexOf('//') === 0) img = 'https:' + img;
            img = img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : '';
            return '<div class="vp-cart__xitem">' +
              (img ? '<img src="' + esc(img) + '" alt="" width="52" height="52" loading="lazy">' : '<span class="vp-cart__xitem-ph"></span>') +
              '<div class="vp-cart__xitem-info"><a href="' + esc(p.url) + '" class="n">' + esc(p.title) + '</a>' +
              '<span class="p">' + money(v.price) + '</span></div>' +
              '<button type="button" class="vp-cart__xadd" data-xadd="' + v.id + '" aria-label="Add ' + esc(p.title) + '">Add</button>' +
            '</div>';
          }).join('');
          xsellEl.hidden = false;
        });
      })
      .catch(function () { xsellEl.hidden = true; });
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }

  function changeQty(key, qty) {
    if (busy) return; busy = true;
    post('/cart/change.js', { id: key, quantity: qty })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  // Swap a line between one-time and subscription (Shopify has no in-place selling_plan change: remove + re-add).
  function setPlan(key, vid, qty, planId) {
    if (busy) return; busy = true;
    post('/cart/change.js', { id: key, quantity: 0 })
      .then(function () {
        var item = { id: parseInt(vid, 10), quantity: parseInt(qty, 10) };
        if (planId) item.selling_plan = planId;
        return post('/cart/add.js', { items: [item] });
      })
      .then(function () { return refresh(); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function addItems(items) {
    return post('/cart/add.js', { items: items })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refresh(); })
      .then(function (cart) { setOpen(true); return cart; });
  }

  // Reads the pet list without depending on vp-pets.js being present: it caches into
  // sessionStorage under the same key, and a miss simply means no dog data is attached.
  function firstPet() {
    try {
      if (window.VPPets && typeof window.VPPets.load === 'function') {
        // Warm the cache for next time; this call is synchronous-miss tolerant.
        window.VPPets.load();
      }
      var raw = sessionStorage.getItem('vp_pets_cache');
      var pets = raw ? JSON.parse(raw) : null;
      return (pets && pets.length) ? pets[0] : null;
    } catch (e) { return null; }
  }

  // --- events ---
  drawer.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-vp-cart-close]'))) { setOpen(false); return; }
    if ((el = t.closest('[data-qty-plus]'))) { var li = el.closest('.vp-cart__line'); changeQty(el.getAttribute('data-qty-plus'), +li.querySelector('.vp-cart__qty-n').textContent + 1); return; }
    if ((el = t.closest('[data-qty-minus]'))) { var li2 = el.closest('.vp-cart__line'); changeQty(el.getAttribute('data-qty-minus'), Math.max(0, +li2.querySelector('.vp-cart__qty-n').textContent - 1)); return; }
    if ((el = t.closest('[data-remove]'))) { changeQty(el.getAttribute('data-remove'), 0); return; }
    if ((el = t.closest('[data-plan-on]'))) {
      var onVid = el.getAttribute('data-vid');
      // Their own cadence if we've seen it this session, otherwise the product's default.
      setPlan(el.getAttribute('data-plan-on'), onVid, el.getAttribute('data-qty'), LAST_PLAN[onVid] || PLANS[onVid].plan);
      return;
    }
    if ((el = t.closest('[data-plan-off]'))) {
      var offVid = el.getAttribute('data-vid');
      LAST_PLAN[offVid] = parseInt(el.getAttribute('data-cur-plan'), 10) || null;
      setPlan(el.getAttribute('data-plan-off'), offVid, el.getAttribute('data-qty'), null);
      return;
    }
    if ((el = t.closest('[data-xadd]'))) {
      el.textContent = 'Adding…'; el.disabled = true;
      addItems([{ id: parseInt(el.getAttribute('data-xadd'), 10), quantity: 1 }]).catch(function () { el.textContent = 'Add'; el.disabled = false; });
      return;
    }
  });
  overlay.addEventListener('click', function () { setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false); });

  // Open on header cart icon (progressive enhancement — falls back to /cart if JS fails)
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-vp-cart-open]');
    if (!link) return;
    e.preventDefault();
    setOpen(true);
    refresh();
  });

  // Intercept any add-to-cart form (PDP buy box) → AJAX add + open drawer
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var item = { id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1 };
    if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
    // Preserve line-item properties (name="properties[Key]") — dog weight, daily dose, refill date, etc.
    var _props = {};
    fd.forEach(function (val, key) { var m = key.match(/^properties\[(.+)\]$/); if (m && val) _props[m[1]] = val; });

    // Attach the saved dog to EVERY line item, not just weight-dosed products. Treats,
    // topicals and one-offs previously carried no dog data at all, which is why the Klaviyo
    // sync could only ever work for Hip & Joint. Anything the form already set wins — the
    // PDP's weight-band picker is more specific than the saved profile.
    var pet = firstPet();
    if (pet) {
      if (!_props['Dog'] && pet.name) _props['Dog'] = pet.name;
      if (!_props['Dog weight'] && pet.weight_lb) _props['Dog weight'] = pet.weight_lb + ' lb';
    }
    if (Object.keys(_props).length) item.properties = _props;
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    addItems([item])
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = label; } });
  });

  window.VPCart = { open: function () { setOpen(true); return refresh(); }, close: function () { setOpen(false); }, refresh: refresh, addItems: addItems };
})();
